import type { components } from '@social-studio/operator-client';
import { useQuery } from '@tanstack/react-query';
import { api, ApiFailure, call } from '../../lib/api';

export type OperatorMe = components['schemas']['OperatorMeDto'];
export type OperatorPermission = OperatorMe['permissions'][number];

export const ME_QUERY_KEY = ['operator-me'] as const;

/**
 * The signed-in operator (`GET /v1/operator/me`), `null` without a session.
 * A pending session (password done, second factor missing) is a value with
 * `verified: false`; only the sign-in page accepts that.
 */
export function useOperatorMe() {
  return useQuery({
    queryKey: ME_QUERY_KEY,
    queryFn: async (): Promise<OperatorMe | null> => {
      try {
        return await call(() => api.GET('/v1/operator/me'));
      } catch (error) {
        if (error instanceof ApiFailure && error.status === 401) return null;
        throw error;
      }
    },
    staleTime: 60_000,
  });
}
